import React from 'react';
import home from '../assets/ic_round-home.png';
import '../styles/PageIntro.css';

const PageIntro = ({ tour }) => {
  if (!tour) return null; // Avoid errors if tour is undefined

  return (
    <div className="page-intro">
      <div className="page-intro-nav">
        <img src={home} alt="home" style={{ marginRight: '8px' ,fontWeight: '700'}} />
        {'>'} Holidays {'>'} {tour.Name}
      </div>
    </div>
  );
};

export default PageIntro;
